import styled from 'styled-components';

export const ToastContainer = styled.div`
  width: 340px;
  height: 174px;
  background: var(--color-surface);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .iconToast {
    height: 60px;
    width: 60px;
  }

  .descriptionToast {
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    color: var(--color-text);
  }
`;
